/**
 * The refusal Probe's routes word themselves: an organization limited to
 * approved AI providers, which Probe's voice service is not one of. The
 * briefing and the call both meet it, and say it the same way.
 *
 * @module components/regulation/probe/probeRefusal
 */
import { ProbeRefusal } from "@amoreg/contracts";
import * as Option from "effect/Option";
import * as Schema from "effect/Schema";

export const RESTRICTED_PROVIDERS_COPY =
  "Voice interviews aren't available for this organization. It is limited to approved AI providers, and Probe's voice service isn't one of them.";

const decodeRefusal = Schema.decodeUnknownOption(Schema.fromJsonString(ProbeRefusal));
const RESTRICTED_PROVIDERS_PHRASE = "approved AI providers";

/** Whether a response refused Probe for the organization's AI providers rather than its membership. */
export const isRestrictedProvidersRefusal = (status: number, body: string): boolean =>
  status === 403 && (Option.isSome(decodeRefusal(body)) || body.includes(RESTRICTED_PROVIDERS_PHRASE));
